import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-800 w-full flex justify-between items-center" }
const _hoisted_2 = { class: "crumbs p-2" }
const _hoisted_3 = { class: "crumb" }
const _hoisted_4 = {
  key: 0,
  class: "crumb"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "crumb"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "History", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "crumb"
}
const _hoisted_10 = { class: "px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode("Tally")
          ], undefined, true),
          _: 1
        })
      ]),
      (_ctx.game)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.player || _ctx.$route.name === 'history')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'game', params: { id: _ctx.game.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.game.name), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.game.name), 1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.$route.name === 'history')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.player)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.player.name), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.$route.name !== 'about')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/about",
            class: "text-green-300 text-xl no-underline cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createTextVNode("?")
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}